<!-- Client list — layout aligned with project management dashboards -->
<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6 client-container">

  <!-- Header -->
  <div class="mb-8">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h1 class="text-3xl font-bold text-gray-900 mb-2">{{ 'clientManagement' | translate }}</h1>
        <p class="text-gray-600">{{ 'manageClients' | translate }}</p>
      </div>
      <div class="flex flex-wrap gap-4">
        <div class="bg-white rounded-lg px-4 py-3 shadow-sm border border-gray-200">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <div>
              <p class="text-sm text-gray-600">{{ 'totalClients' | translate }}</p>
              <p class="text-lg font-semibold text-gray-900">{{ clients.length }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Search & filters -->
  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 mb-8">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col xl:flex-row xl:items-end gap-4">
        <div class="flex-1 min-w-0">
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <input
              type="text"
              [(ngModel)]="searchTerm"
              (input)="applyFilter()"
              placeholder="Search by name, contact person, phone, or location..."
              class="block w-full pl-10 pr-10 py-3 border border-gray-300 rounded-xl leading-5 bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200"
            />
            <button
              type="button"
              *ngIf="searchTerm"
              (click)="clearSearch()"
              class="absolute inset-y-0 right-2 flex items-center text-gray-400 hover:text-gray-600 p-1"
              [attr.aria-label]="'Clear search'"
            >
              <mat-icon class="!text-lg">close</mat-icon>
            </button>
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 xl:flex xl:flex-nowrap xl:gap-3">
          <select
            [(ngModel)]="selectedType"
            (change)="applyFilter()"
            class="w-full xl:w-56 px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none text-gray-700"
          >
            <option value="">All Types</option>
            <option *ngFor="let type of clientTypes" [value]="type.value">{{ type.label }}</option>
          </select>
          <select
            [(ngModel)]="selectedState"
            (change)="applyFilter()"
            class="w-full xl:w-56 px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none text-gray-700"
          >
            <option value="">All States</option>
            <option *ngFor="let state of allState" [value]="state">{{ state }}</option>
          </select>
        </div>
      </div>
      <div class="flex flex-wrap items-center justify-end gap-2 pt-1 border-t border-gray-100 xl:border-t-0 xl:pt-0">
        <button
          type="button"
          (click)="clearFilters()"
          class="inline-flex items-center px-4 py-2.5 border border-gray-300 text-sm font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-sm"
        >
          <mat-icon class="mr-1 !text-lg">filter_alt_off</mat-icon>
          {{ 'clearFilters' | translate }}
        </button>
        <button
          type="button"
          (click)="loadClients()"
          class="inline-flex items-center px-4 py-2.5 border border-gray-300 text-sm font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-sm"
        >
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          {{ 'refresh' | translate }}
        </button>
        <button
          type="button"
          (click)="openCreateDialog()"
          class="inline-flex items-center px-6 py-2.5 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-lg"
        >
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          {{ 'addNewClient' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex flex-col items-center justify-center py-20 bg-white rounded-2xl shadow-lg border border-gray-200">
    <mat-spinner diameter="48"></mat-spinner>
    <p class="text-gray-600 mt-4">Loading clients...</p>
  </div>

  <!-- Table card -->
  <div *ngIf="!loading" class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
      <h2 class="text-lg font-semibold text-gray-900">{{ 'clientsOverview' | translate }}</h2>
      <p class="text-sm text-gray-600 mt-1">{{ 'clientsOverviewHint' | translate }}</p>
    </div>

    <div *ngIf="dataSource.data.length > 0" class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="w-full client-table">
        <ng-container matColumnDef="client_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ 'CLIENT_NAME' | translate }}
          </th>
          <td mat-cell *matCellDef="let client" class="px-6 py-4">
            <div class="client-name-cell">
              <span class="client-name">{{ client.client_first_name }} {{ client.client_last_name }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="contact_number">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ 'CLIENT_NUMBER' | translate }}
          </th>
          <td mat-cell *matCellDef="let client" class="px-6 py-4">
            <div class="phone-cell">
              <mat-icon class="cell-icon">phone</mat-icon>
              <a [href]="'tel:' + client.contact_number" class="phone-link" (click)="$event.stopPropagation()">{{ client.contact_number }}</a>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ 'LOCATION' | translate }}
          </th>
          <td mat-cell *matCellDef="let client" class="px-6 py-4">
            <div class="location-cell">
              <mat-icon class="cell-icon">location_on</mat-icon>
              <div class="location-details">
                <span class="primary-location">{{ client.state }}, {{ client.district }}</span>
                <span class="secondary-location">{{ client.sub_district }}, {{ client.villages }}</span>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="additional_info">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ 'additionalInfo' | translate }}
          </th>
          <td mat-cell *matCellDef="let client" class="px-6 py-4">
            <div class="additional-info-cell">
              <div class="info-item" *ngIf="client.type">
                <mat-icon class="info-icon">person_outline</mat-icon>
                <span class="info-text">{{ client.type }}</span>
              </div>
              <div class="info-item" *ngIf="client.khasra_no">
                <mat-icon class="info-icon">description</mat-icon>
                <span class="info-text">{{ 'Khasra_no' | translate }}: {{ client.khasra_no }}</span>
              </div>
              <div class="info-item" *ngIf="client.area">
                <mat-icon class="info-icon">straighten</mat-icon>
                <span class="info-text">{{ 'Area' | translate }}: {{ client.area }}</span>
              </div>
            </div>
            <span class="no-info" *ngIf="!client.khasra_no && !client.area && !client.type">-</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ 'createdDate' | translate }}
          </th>
          <td mat-cell *matCellDef="let client" class="px-6 py-4 text-sm text-gray-700">
            <div class="date-cell">
              <mat-icon class="cell-icon">schedule</mat-icon>
              {{ formatDate(client.created_at) }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ 'action' | translate }}
          </th>
          <td mat-cell *matCellDef="let client" class="px-6 py-4" (click)="$event.stopPropagation()">
            <div class="actions-cell justify-start">
              <button mat-icon-button color="primary" (click)="openViewDialog(client)" matTooltip="View Details">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button color="accent" (click)="openEditDialog(client)" matTooltip="Edit Client">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="openDeleteDialog(client)" matTooltip="Delete Client">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-50"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="table-row hover:bg-gray-50 transition-colors duration-150 cursor-pointer"
          (click)="openViewDialog(row)"
          [class.selected-row]="selectedClient?.client_id === row.client_id"
        ></tr>
      </table>
    </div>

    <!-- Empty -->
    <div *ngIf="dataSource.data.length === 0" class="text-center py-12 px-4">
      <div class="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <mat-icon class="!text-5xl text-gray-400">people_outline</mat-icon>
      </div>
      <h3 class="text-lg font-medium text-gray-900 mb-2">{{ 'noClientsFound' | translate }}</h3>
      <p class="text-gray-500 mb-2" *ngIf="searchTerm || selectedType || selectedState">{{ 'noClientsMatch' | translate }}</p>
      <p class="text-gray-500 mb-6" *ngIf="!searchTerm && !selectedType && !selectedState">{{ 'noClientsAdded' | translate }}</p>
      <button
        type="button"
        (click)="openCreateDialog()"
        class="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200"
      >
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        {{ 'addNewClient' | translate }}
      </button>
    </div>

    <!-- Pagination -->
    <div *ngIf="totalClients > 0" class="px-6 py-4 border-t border-gray-200 bg-gray-50">
      <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div class="text-sm text-gray-600">
          Showing {{ paginationFrom }} to {{ paginationTo }} of {{ totalClients }} clients
        </div>
        <mat-paginator
          [length]="totalClients"
          [pageSize]="pageSize"
          [pageSizeOptions]="[5, 10, 25, 50, 100]"
          [pageIndex]="currentPage"
          (page)="onPageChange($event)"
          showFirstLastButtons
          class="bg-transparent client-paginator"
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>

<!-- Create Client Dialog -->
<mat-dialog-content *ngIf="showCreateDialog" class="dialog-content">
  <div class="dialog-header">
    <h2 mat-dialog-title> {{'addNewClient' | translate}}</h2>
    <button mat-icon-button (click)="closeCreateDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <form [formGroup]="clientForm" class="client-form">
      <div class="form-row">
        <div class="col">
            <mat-label>{{'clientFirstName' | translate}} *</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="client_first_name" placeholder="Enter client first name">
            <mat-error *ngIf="getFieldError('client_first_name')">{{ getFieldError('client_first_name') }}</mat-error>
          </mat-form-field>
        </div>
        <div class="col">
            <mat-label>{{'clientLastName' | translate}} *</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="client_last_name" placeholder="Enter client last name">
            <mat-error *ngIf="getFieldError('client_last_name')">{{ getFieldError('client_last_name') }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
          <div class="col">
            <mat-label>{{'clientEmail' | translate}} *</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="email" placeholder="Enter client last name">
            <mat-error *ngIf="getFieldError('email')">{{ getFieldError('email') }}</mat-error>
          </mat-form-field>
        </div>
        <div class="col">
            <mat-label>{{'clientType' | translate}} *</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <mat-select formControlName="type">
              <mat-option *ngFor="let type of clientTypes" [value]="type.value">
                {{ type.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="getFieldError('type')">{{ getFieldError('type') }}</mat-error>
          </mat-form-field>
        </div>
        <!-- <div class="col">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Contact Person *</mat-label>
            <input matInput formControlName="contact_person" placeholder="Enter contact person name">
            <mat-error *ngIf="getFieldError('contact_person')">{{ getFieldError('contact_person') }}</mat-error>
          </mat-form-field>
        </div> -->
      </div>

      <div class="form-row">
        <div class="col">
            <mat-label>{{'contactNumber' | translate}} *</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="contact_number" placeholder="Enter phone number">
            <mat-error *ngIf="getFieldError('contact_number')">{{ getFieldError('contact_number') }}</mat-error>
          </mat-form-field>
        </div>
        <div class="col">
            <mat-label> {{"line1"| translate }}</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="line_1" placeholder="Enter line 1 address">
            <mat-error *ngIf="getFieldError('line_1')">{{ getFieldError('line_1') }}</mat-error>
          </mat-form-field>
        </div>
          <div class="col">
            <mat-label>{{"line2"| translate }}</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="line_2" placeholder="Enter line 2 address">
            <mat-error *ngIf="getFieldError('line_2')">{{ getFieldError('line_2') }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        <div class="col">
            <mat-label>{{'STATE' | translate}} *</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <mat-select formControlName="state" placeholder="Select state">
              <mat-option *ngFor="let state of allState" [value]="state">
                {{ state }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="getFieldError('state')">{{ getFieldError('state') }}</mat-error>
          </mat-form-field>
        </div>
        <div class="col">
            <mat-label>{{'DISTRICT' | translate}} *</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <mat-select formControlName="district" placeholder="Select district" [disabled]="!allDistricts.length">
              <mat-option *ngFor="let district of allDistricts" [value]="district">
                {{ district }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="getFieldError('district')">{{ getFieldError('district') }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        <div class="col">
            <mat-label>{{'SUBDISTRICT' | translate}} *</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <mat-select formControlName="sub_district" placeholder="Select sub-district" [disabled]="!allSubDistricts.length">
              <mat-option *ngFor="let subDistrict of allSubDistricts" [value]="subDistrict">
                {{ subDistrict }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="getFieldError('sub_district')">{{ getFieldError('sub_district') }}</mat-error>
          </mat-form-field>
        </div>
        <div class="col">
            <mat-label>{{'VILLAGES' | translate}} *</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <mat-select formControlName="villages" placeholder="Select village" [disabled]="!allVillage.length">
              <mat-option *ngFor="let village of allVillage" [value]="village">
                {{ village }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="getFieldError('villages')">{{ getFieldError('villages') }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        <div class="col">
            <mat-label>{{'Khasra_no' | translate}}</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="khasra_no" placeholder="Enter khasra number">
          </mat-form-field>
        </div>
        <div class="col">
            <mat-label>{{'Area' | translate}}</mat-label>

          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="area" placeholder="Enter area">
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div class="dialog-actions">
    <button mat-button (click)="closeCreateDialog()">{{'CANCEL' | translate}}</button>
    <button mat-raised-button color="primary" [disabled]="!clientForm.valid" (click)="createClient()">
      {{'createClient' | translate}}
    </button>
  </div>
</mat-dialog-content>

<!-- Edit Client Dialog -->
<mat-dialog-content *ngIf="showEditDialog" class="dialog-content">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{'editClient' | translate}}</h2>
    <button mat-icon-button (click)="closeEditDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <form [formGroup]="clientForm" class="client-form">
      <!-- Same form fields as create dialog -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>{{'clientFirstName' | translate}}*</mat-label>
          <input matInput formControlName="client_name" placeholder="Enter client name">
          <mat-error *ngIf="getFieldError('client_name')">{{ getFieldError('client_name') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>{{'clientType' | translate}} *</mat-label>
          <mat-select formControlName="type">
            <mat-option *ngFor="let type of clientTypes" [value]="type.value">
              {{ type.label }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="getFieldError('type')">{{ getFieldError('type') }}</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <!-- <mat-form-field appearance="outline" class="form-field">
          <mat-label>Contact Person *</mat-label>
          <input matInput formControlName="contact_person" placeholder="Enter contact person name">
          <mat-error *ngIf="getFieldError('contact_person')">{{ getFieldError('contact_person') }}</mat-error>
        </mat-form-field> -->

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>{{'contactNumber' | translate}} *</mat-label>
          <input matInput formControlName="contact_number" placeholder="Enter phone number">
          <mat-error *ngIf="getFieldError('contact_number')">{{ getFieldError('contact_number') }}</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>{{'STATE' | translate}} *</mat-label>
          <mat-select formControlName="state" placeholder="Select state">
            <mat-option *ngFor="let state of allState" [value]="state">
              {{ state }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="getFieldError('state')">{{ getFieldError('state') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>{{'DISTRICT' | translate}} *</mat-label>
          <mat-select formControlName="district" placeholder="Select district" [disabled]="!allDistricts.length">
            <mat-option *ngFor="let district of allDistricts" [value]="district">
              {{ district }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="getFieldError('district')">{{ getFieldError('district') }}</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>{{'SUBDISTRICT' | translate}} *</mat-label>
          <mat-select formControlName="sub_district" placeholder="Select sub-district" [disabled]="!allSubDistricts.length">
            <mat-option *ngFor="let subDistrict of allSubDistricts" [value]="subDistrict">
              {{ subDistrict }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="getFieldError('sub_district')">{{ getFieldError('sub_district') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>{{'VILLAGES' | translate}} *</mat-label>
          <mat-select formControlName="villages" placeholder="Select village" [disabled]="!allVillage.length">
            <mat-option *ngFor="let village of allVillage" [value]="village">
              {{ village }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="getFieldError('villages')">{{ getFieldError('villages') }}</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>{{'Khasra_no' | translate}}</mat-label>
          <input matInput formControlName="khasra_no" placeholder="Enter khasra number">
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>{{'Area' | translate}}</mat-label>
          <input matInput formControlName="area" placeholder="Enter area">
        </mat-form-field>
      </div>
    </form>
  </div>

  <div class="dialog-actions">
    <button mat-button (click)="closeEditDialog()">{{'CANCEL' | translate}}</button>
    <button mat-raised-button color="primary" [disabled]="!clientForm.valid" (click)="updateClient()">
      {{'updateClient' | translate}}
    </button>
  </div>
</mat-dialog-content>

<!-- View Client Dialog -->
<mat-dialog-content *ngIf="showViewDialog" class="dialog-content large">
  <div class="dialog-header">
    <h2 mat-dialog-title>Client Details</h2>
    <button mat-icon-button (click)="closeViewDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body" *ngIf="selectedClient">
    <div class="client-details">
      <div class="detail-header">
        <h3>{{ selectedClient.client_first_name }} {{ selectedClient.client_last_name }}</h3>
        <mat-chip-list *ngIf="false">
          <mat-chip [ngClass]="getTypeClass(selectedClient.type)" class="type-chip">
            {{ getTypeText(selectedClient.type) }}
          </mat-chip>
        </mat-chip-list>
      </div>

      <div class="detail-content">
        <div class="detail-section">
          <h4>Contact Information</h4>
          <div class="detail-grid">
            <!-- <div class="detail-item">
              <span class="label">Contact Person:</span>
              <span class="value">{{ selectedClient.contact_person }}</span>
            </div> -->
            <div class="detail-item">
              <span class="label">Phone Number:</span>
              <span class="value">{{ selectedClient.contact_number }}</span>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <h4>Location Information</h4>
          <div class="detail-grid">
            <div class="detail-item">
              <span class="label">State:</span>
              <span class="value">{{ selectedClient.state }}</span>
            </div>
            <div class="detail-item">
              <span class="label">District:</span>
              <span class="value">{{ selectedClient.district }}</span>
            </div>
            <div class="detail-item">
              <span class="label">Sub-District:</span>
              <span class="value">{{ selectedClient.sub_district }}</span>
            </div>
            <div class="detail-item">
              <span class="label">Villages:</span>
              <span class="value">{{ selectedClient.villages }}</span>
            </div>
          </div>
        </div>

        <div class="detail-section" *ngIf="selectedClient.khasra_no || selectedClient.area">
          <h4>Additional Information</h4>
          <div class="detail-grid">
            <div class="detail-item" *ngIf="selectedClient.khasra_no">
              <span class="label">Khasra Number:</span>
              <span class="value">{{ selectedClient.khasra_no }}</span>
            </div>
            <div class="detail-item" *ngIf="selectedClient.area">
              <span class="label">Area:</span>
              <span class="value">{{ selectedClient.area }}</span>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <h4>Timestamps</h4>
          <div class="detail-grid">
            <div class="detail-item">
              <span class="label">Created:</span>
              <span class="value">{{ formatDate(selectedClient.created_at) }}</span>
            </div>
            <div class="detail-item" *ngIf="selectedClient.updated_at">
              <span class="label">Last Updated:</span>
              <span class="value">{{ formatDate(selectedClient.updated_at) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-button (click)="closeViewDialog()">Close</button>
    <button mat-raised-button color="accent" (click)="openEditDialog(selectedClient)">
      {{'editClient' | translate}}
    </button>
  </div>
</mat-dialog-content>

<!-- Delete Confirmation Dialog -->
<mat-dialog-content *ngIf="showDeleteDialog" class="dialog-content small">
  <div class="dialog-header">
    <h2 mat-dialog-title>Delete Client</h2>
    <button mat-icon-button (click)="closeDeleteDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <div class="delete-confirmation">
      <mat-icon class="warning-icon">warning</mat-icon>
      <h3>Are you sure?</h3>
      <p>You are about to delete the client <strong>{{ selectedClient?.client_name }}</strong>. This action cannot be undone.</p>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-button (click)="closeDeleteDialog()">Cancel</button>
    <button mat-raised-button color="warn" (click)="deleteClient()">
      Delete Client
    </button>
  </div>
</mat-dialog-content>